import React, { useState, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { blogs } from "../data/blogs";
import "./Blog.css"; // Ensure you import the CSS

const CATEGORIES = ["All", "NetSuite", "Salesforce", "Web Development", "Automation"];

export default function Blog() {
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredBlogs = useMemo(() => {
    return activeCategory === "All" ? blogs : blogs.filter(b => b.category === activeCategory);
  }, [activeCategory]);

  return (
    <div className="blog-page-v2">
      <Helmet>
        <title>Technical Insights & ERP Strategy | ITSeva Hub</title>
        <meta name="description" content="Professional engineering blog covering NetSuite, Salesforce, and Modern Web Dev." />
      </Helmet>

      <section className="blog-hero-section">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <span className="hero-badge">Engineering Hub</span>
          <h1>Insights for the <br/> <span className="text-gradient">Modern Enterprise</span></h1>
          <p>Deep dives into digital transformation and business automation.</p>
        </motion.div>
      </section>

      <div className="blog-filters">
        {CATEGORIES.map(cat => (
          <button 
            key={cat} 
            className={`filter-btn ${activeCategory === cat ? "active" : ""}`}
            onClick={() => setActiveCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="blog-grid">
        <AnimatePresence mode="popLayout">
          {filteredBlogs.map((blog) => (
            <motion.article 
              layout
              key={blog.slug}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              className="blog-card"
            >
              <Link to={`/blog/${blog.slug}`} style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="card-image">
                  <img src={blog.image} alt={blog.title} />
                  <span className="card-tag">{blog.category}</span>
                </div>
                <div className="card-body">
                  <div className="card-meta">{blog.date} • {blog.readTime}</div>
                  <h2>{blog.title}</h2>
                  <p>{blog.desc}</p>
                  <span className="read-link">Explore Guide →</span>
                </div>
              </Link>
            </motion.article>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
}